export default "__VITE_ASSET__X5lwH781__"